// @flow

// Links to best of category posts

const SchedulingAppsLink = {
  text: 'Scheduling Apps',
  href: '/blog/best-meeting-scheduler-apps/',
};

const ToDoListAppsLink = {
  text: 'To-do List Apps',
  href: '/blog/best-todo-list-apps/',
};

const PresentationAppsLink = {
  text: 'Presentation Software',
  href: '/blog/best-powerpoint-alternatives/',
};

const SpreadsheetAppsLink = {
  text: 'Spreadsheet Software',
  href: '/blog/best-spreadsheet-excel-alternative/',
};

const TimeTrackingAppsLink = {
  text: 'Time Tracking Apps',
  href: '/blog/best-time-tracking-apps/',
};

const ECommerceAppsLink = {
  text: 'Ecommerce Apps',
  href: '/learn/ecommerce/best-ecommerce-shopping-cart-software/',
};

// Links to app pages on Zapier

const GithubLink = {
  text: 'GitHub',
  href: '/apps/github/integrations',
};

const TrelloLink = {
  text: 'Trello',
  href: '/apps/trello/integrations',
};

const TodoistLink = {
  text: 'Todoist',
  href: '/apps/todoist/integrations',
};

const XeroLink = {
  text: 'Xero',
  href: '/apps/xero/integrations',
};

const FacebookGroupsLink = {
  text: 'Facebook Groups',
  href: '/apps/facebook-groups/integrations',
};

const JIRALink = {
  text: 'JIRA',
  href: '/apps/jira/integrations',
};

const DropboxLink = {
  text: 'Dropbox',
  href: '/apps/dropbox/integrations',
};

const EvernoteLink = {
  text: 'Evernote Business',
  href: '/apps/evernote-business/integrations',
};

const GoogleSheetsLink = {
  text: 'Google Sheets',
  href: '/apps/google-sheets/integrations',
};

const Office365Link = {
  text: 'Office 365',
  href: '/apps/office-365/integrations',
};

const WordPressLink = {
  text: 'WordPress',
  href: '/apps/wordpress/integrations',
};

const DocuSignLink = {
  text: 'DocuSign',
  href: '/apps/docusign/integrations',
};

// Links to blog posts

const ProductivityKillersLink = {
  image:
    'https://images.zapier.com/storage/blog/85725c45a2cc121b98f7857c8e0d2322.250x250.jpeg',
  text: 'How to Avoid the 9 Things That Hurt Productivity Most',
  href: '/blog/avoid-productivity-killers/',
};

const SmartGoalsLink = {
  image:
    'https://images.zapier.com/storage/blog/5c431a121616b98515b868b20104d39d.250x250.png',
  text:
    'Reach Any Goal This Year with a Spreadsheet, a Calendar, and the SMART System',
  href: '/blog/smart-goals/',
};

const BreakBadHabits = {
  image:
    'https://images.zapier.com/storage/blog/927266bd5282c9b0967bf6dcfe9875c4.250x250.jpg',
  text: 'Break Bad Work Habits with the Help of These 10 Apps',
  href: '/blog/change-bad-work-habits/',
};

// Submenu
const exploreLink = {
  href: '/apps/integrations',
  icon: 'navExplore',
  isExternal: true,
  text: 'Explore',
  submenu: [
    {
      title: 'Best Of',
      links: [
        SchedulingAppsLink,
        ToDoListAppsLink,
        PresentationAppsLink,
        SpreadsheetAppsLink,
        TimeTrackingAppsLink,
        ECommerceAppsLink,
      ],
    },
    {
      title: 'Explore',
      links: [
        GithubLink,
        TrelloLink,
        TodoistLink,
        XeroLink,
        FacebookGroupsLink,
        JIRALink,
        DropboxLink,
        EvernoteLink,
        GoogleSheetsLink,
        Office365Link,
        WordPressLink,
        DocuSignLink,
      ],
    },
    {
      title: 'Tips & Advice',
      links: [ProductivityKillersLink, SmartGoalsLink, BreakBadHabits],
    },
  ],
};

export default exploreLink;
